import { Link } from 'react-router-dom';
import { themeClasses } from '@member-portal/ui';

interface AdvisorPageHeroProps {
  ctaLabel?: string;
  ctaHref?: string;
  onCtaClick?: (e: React.MouseEvent) => void;
}

function AdvisorPageHero({
  ctaLabel = 'Advisor Sign Up',
  ctaHref,
  onCtaClick,
}: AdvisorPageHeroProps) {
  const ctaClassName = `px-8 py-4 bg-white text-black ${themeClasses.text.button} hover:opacity-90 transition-colors duration-300`;

  return (
    <section className="relative py-32 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: 'url(/images/images/sara-dubler-Koei_7yYtIo-unsplash.jpg)' }}
      />
      <div className="absolute inset-0 bg-black/50" />
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className={`${themeClasses.title.h1} text-white mb-6`}>
          A Curated Platform for Travel Advisors
        </h1>
        <p className={`${themeClasses.text.body} text-white text-lg md:text-xl max-w-3xl mx-auto mb-10`}>
          Discover a world-class collection of hotels, resorts, villas, private residences, specialty
          cruise lines and providers of luxury goods and services.
        </p>
        {ctaHref ? (
          <Link to={ctaHref} className={ctaClassName}>
            {ctaLabel}
          </Link>
        ) : (
          <a href="#advisor-signup" onClick={onCtaClick} className={ctaClassName}>
            {ctaLabel}
          </a>
        )}
      </div>
    </section>
  );
}

export default AdvisorPageHero;
